import TablePaginadaBasic, { ITablePaginadaBasicProps } from "@/Components/Base/Table/TablePaginadaBasic";
import Trabalho from "@/Models/Sistema/Trabalho";
import ConciliacaoAuttarDesativarPopconfirm from "./ConciliacaoAuttarDesativarPopconfirm";
import ComponentePermissao, { usePermitido } from "@/Components/Base/Permissao/ComponentePermissao";
import { EnumTrabalhoSituacao } from "@/Models/Sistema/Trabalho/TrabalhoSituacao";
import { AxiosResponse } from "axios";
import ConciliacaoLogTable from "./Log/ConciliacaoLogTable";
import { Flex, Tag, Tooltip, Button } from "antd";
import { useConciliacaoAuttarBaixarArquivo } from "@/Services/Financeiro/Conta/ConciliacaoAuttarService";
import { EnumTrabalhoTipo } from "@/Models/Sistema/Trabalho/TrabalhoTipo";
export interface IConciliacaoAuttarTableBasicProps extends ITablePaginadaBasicProps<Trabalho> {
    onSuccess?:(response:AxiosResponse<void, any>, input:Trabalho) => void;
    codTrabalhoTipo:EnumTrabalhoTipo;
}
export default function ConciliacaoAuttarTableBasic({
    onSuccess,
    codTrabalhoTipo,
    ...rest
}: IConciliacaoAuttarTableBasicProps) {

    const {
        permitido
    } = usePermitido({
        permissoes : [ "FinanceiroContaConciliacaoAuttarLogListar" ]
    });

    const {
        mutate,
        isPending
    } = useConciliacaoAuttarBaixarArquivo({
        codTrabalhoTipo,
        onSuccess(response, variables, context) {
            const elementoA = document.createElement("a");
            document.body.appendChild(elementoA);
            elementoA.id = "linkDownloadArquivo";
            elementoA.style.display = "none";
            //elementoA.style = "display: none";
            const contentDisposition = Object.fromEntries(
                ((response.headers["content-disposition"] as string) ?? (response.headers["Content-Disposition"] as string))
                    .split(";")
                    .map((grupo) => [grupo.split("=")[0]?.trim(), grupo.split("=")[1]?.trim()])
            );
            const url = window.URL.createObjectURL(response.data);

            elementoA.href = url;
            elementoA.download = contentDisposition["filename"];
            elementoA.click();

            document.body.removeChild(elementoA);
        },
    });

    return <TablePaginadaBasic
        {...rest}
        rowKey={(m) => m.codigo.toString()}
        disableResponsiveness={true}
        tableLayout="auto"
        scroll={{
            x: true,
        }}
        showHeader={true}
        minColWidthIfResponsivenessDisabled={"120px"}
        expandable={{
            expandedRowRender(record, index, indent, expanded) {
                return expanded ? <ConciliacaoLogTable codTrabalhoTipo={codTrabalhoTipo} initialValues={{
                    trabalhoLog : {
                        codTrabalho : record.codigo
                    }
                }} /> : <></>;
            },
            rowExpandable : () => permitido
        }}
        columns={[
            {
                key : "codigo",
                title : "#",
                dataIndex : ["codigo"],
                // breakpoints : { xs : 10, sm : 10, md : 4, lg : 4, xl : 2, xxl : 2 }
            },
            {
                key : "dataOcorrencia",
                title : "Data",
                dataIndex : ["dataOcorrencia"],
                render: (value: Date) => value.toLocaleString().replace(',', '').substring(0, 16),
                // breakpoints : { xs : 12, sm : 12, md : 6, lg : 6, xl : 3, xxl : 3 }
            },
            {
                key : "identificador",
                title : "Chave",
                dataIndex : ["identificadorInterno"],
                render: (value: string, record) => <Button style={{ textAlign : "left" }} type="link" loading={isPending} onClick={() => mutate({ codTrabalho : record.codigo })}>{value}</Button>, 
                // breakpoints : { xs : 24, sm : 12, md : 12, lg : 12, xl : 6, xxl : 6 }
            },
            {
                key : "registros",
                title : "Registros",
                dataIndex : ["registrosProcessados"],
                render(value, record, index) { 
                    return <Flex>
                        <Tooltip title="Total">
                            <Tag color="default">{value ?? 0}</Tag>
                        </Tooltip>
                        <Tooltip title="Com sucesso">
                            <Tag color="success">{record.processadosComSucesso ?? 0}</Tag>
                        </Tooltip>
                        <Tooltip title="Com erro">
                            <Tag color="error">{record.processadosComErro ?? 0}</Tag>
                        </Tooltip>
                    </Flex>
                }
                // breakpoints : { xs : 24, sm : 12, md : 12, lg : 12, xl : 6, xxl : 6 }
            },
            {
                key : "situacao",
                title : "Situação",
                dataIndex : ["situacao", "nome"],
                // breakpoints : { xs : 24, sm : 12, md : 6, lg : 6, xl : 3, xxl : 3 }
            },
            {
                key : "acoes",
                title : "Ações",
                dataIndex : ["codigo"],
                // breakpoints : { xs : 24, sm : 12, md : 6, lg : 6, xl : 3, xxl : 3 },
                render(value, record, index) {
                    return (record.ativo && record.codSituacao == EnumTrabalhoSituacao.AExecutar) && <ComponentePermissao permissoes={["FinanceiroContaConciliacaoAuttarDesativar"]}>
                        <ConciliacaoAuttarDesativarPopconfirm
                            codTrabalhoTipo={codTrabalhoTipo}
                            trabalho={record}
                            onSuccess={onSuccess}
                        />
                    </ComponentePermissao> || <>-</>;
                },
            }
        ]}
    />
}